declare const __APP_VERSION__: string | undefined;

/** Single source: package.json → Vite `define` (__APP_VERSION__) at build/dev time. */
export function getAppVersion(): string {
  if (typeof __APP_VERSION__ === 'string' && __APP_VERSION__.trim()) {
    return __APP_VERSION__.trim();
  }
  const fromEnv = import.meta.env.VITE_APP_VERSION?.trim();
  if (fromEnv) return fromEnv;
  return '0.0.0';
}

export const APP_VERSION = getAppVersion();
